import React from 'react';
import { DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '@/components/ui/alert-dialog';
import { Progress } from '@/components/ui/progress';
import { Search, Rocket, Video, BarChart3, Users } from 'lucide-react';
import { pillarConfig } from '@/data/AITrainingTransformationData';
import { DSCloseButton } from '@/components/design-system/DSCloseButton';

const iconMap: Record<string, React.ElementType> = {
  Search,
  Rocket,
  Video,
  BarChart3,
  Users
};

interface AssessmentModalHeaderProps {
  currentStep: number;
  totalSteps: number;
  assessmentType: 'ia-diagnostic' | 'training-transformation';
  getProgress: () => number;
  onClose: () => void;
  onConfirmClose: () => void;
  currentCategory?: string;
}

export const AssessmentModalHeader: React.FC<AssessmentModalHeaderProps> = ({
  currentStep,
  totalSteps,
  assessmentType,
  getProgress,
  onClose,
  onConfirmClose,
  currentCategory
}) => {
  const title = assessmentType === 'ia-diagnostic' 
    ? 'Diagnostic AI Digital Transformation' 
    : 'Diagnostic Transformation Formation IA';

  const description = assessmentType === 'ia-diagnostic'
    ? 'Évaluez la maturité IA de votre organisation à travers un diagnostic complet'
    : 'Évaluez votre stratégie d\'apprentissage IA à travers un diagnostic complet';

  const shouldShowAlert = currentStep >= 1 && currentStep < totalSteps - 1;

  return (
    <DialogHeader className="p-6 pb-4 border-b">
      <div className="flex items-center justify-between pr-14">
        <DialogTitle className="text-2xl font-bold" style={{ color: '#D7398B' }}>
          {title}
        </DialogTitle>
        
        {shouldShowAlert ? (
          <AlertDialog>
            <AlertDialogTrigger asChild>
              <DSCloseButton />
            </AlertDialogTrigger>
            <AlertDialogContent className="rounded-3xl" style={{ zIndex: 10000 }}>
              <AlertDialogHeader>
                <AlertDialogTitle>Fermer l'évaluation ?</AlertDialogTitle>
                <AlertDialogDescription>
                  Vos réponses ont été sauvegardées. Vous pourrez reprendre le diagnostic là où vous en étiez.
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel className="rounded-full">Annuler</AlertDialogCancel>
                <AlertDialogAction onClick={onConfirmClose} className="rounded-full">
                  Quitter
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        ) : currentStep === totalSteps - 1 ? null : (
          <DSCloseButton onClick={onClose} />
        )}
      </div>
      
      <DialogDescription className="sr-only">
        {description}
      </DialogDescription>
      
      {currentStep > 0 && currentStep < totalSteps - 1 && (
        <div className="space-y-2">
          <div className="flex justify-between text-sm text-gray-600">
            <span>Étape {currentStep} sur {totalSteps - 1}</span>
            <span>{Math.round(getProgress())}% complété</span>
          </div>
          <Progress value={getProgress()} className="h-2" />
        </div>
      )}

    </DialogHeader>
  );
};
